// src/pages/MatrikaHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MatrikaHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💰" },
    { label: "Digital Learning", emoji: "💡" },
    { label: "Task & Management", emoji: "🗂️" },
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Youth Shopping", emoji: "🛍️" },
    { label: "Recognition & Progress", emoji: "🏅" },
    { label: "Wishes & Fun", emoji: "🎬" },
  ];

  const menuButtons1 = [
    // 💡 DIGITAL LEARNING
    { label: "My Immersive Digital Books", emoji: "📚", link: "/bookshelf", group: "Digital Learning" },
    { label: "Matrika Digital Books", emoji: "📖", link: "/golden7-bookworld", group: "Digital Learning" },
    { label: "Teen Workshops", emoji: "🎓", link: "/teen-trainingworkshop", group: "Digital Learning" },
    { label: "Teen Podcast", emoji: "🎙️", link: "/podcast-mylist", group: "Digital Learning" },
    { label: "eduTube", emoji: "▶️", link: "/edutube/Golden7", group: "Digital Learning" },

    // 💰 DIGITAL INCOME
    { label: "ValueShare", emoji: "💱", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/teen-income", group: "Digital Income" },
    { label: "Introduce User", emoji: "👥📢", link: "/teen-introduce", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🛒🎁", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Marksheet Contest", emoji: "📜🏆", link: "/applause-marksheet-contest", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "📺💎", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Income" },

    // 🗂️ TASK & MANAGEMENT
    { label: "Teen Daily", emoji: "📝", link: "/sheearns-daily", group: "Task & Management" },
    { label: "Teen Diary", emoji: "📔", link: "/mydiary-home", group: "Task & Management" },
    { label: "Teen Journal", emoji: "📔", link: "/myjournal-home", group: "Task & Management" },
    { label: "DeepThinking", emoji: "🧩", link: "/fivewhys-analysis-home", group: "Task & Management" },
    { label: "Goal Board", emoji: "🎯", link: "/sheearns-goalboard", group: "Task & Management" },
    { label: "Kanban", emoji: "📊", link: "/sheearns-kanban", group: "Task & Management" },
    { label: "Digital Writing Paper", emoji: "✍️📄", link: "/sheearns-touchbookplain", group: "Task & Management" },
    { label: "Digital Writing Grid", emoji: "✍️📊", link: "/sheearns-touchbookgrid", group: "Task & Management" },
    { label: "Digital Voice Writing", emoji: "🎙️✍️", link: "/sheearns-voicebook", group: "Task & Management" },

    // 🛍️ Golden7 SHOPPING
    { label: "My Orders", emoji: "📦", link: "/myprofile-myorders", group: "Youth Shopping" },
    { label: "Personal Shopping", emoji: "👜💃", link: "/orderflow-home", group: "Youth Shopping" },
    { label: "Gift", emoji: "🎁💖", link: "/giftify", group: "Youth Shopping" },
    { label: "RoomAnywhere", emoji: "🏠🌍", link: "/roomanywhere", group: "Youth Shopping" },
    { label: "ThinkStylus", emoji: "🖊️💡", link: "/thinkstylus", group: "Youth Shopping" },
    { label: "MADSmania", emoji: "📄🔁🎨", link: "/madsmania-home", group: "Youth Shopping" },
    { label: "DSeven", emoji: "🧩7️⃣🌈", link: "/dseven", group: "Youth Shopping" },
    { label: "Digital Tryout", emoji: "🪄💻", link: "/digitaltryout", group: "Youth Shopping" },
    { label: "Window Shopping", emoji: "🏬👀", link: "/twiworld", group: "Youth Shopping" },

    // 🪞 SHELF REFLECTION
    { label: "My Teen Card", emoji: "💖", link: "/digitalteencard", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️", link: "/golden7-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "AI Counselling", emoji: "🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "My Jugaad / Hack", emoji: "🧱", link: "/jugaad", group: "Self Reflection" },
    { label: "My Think5Whys Profile", emoji: "🧱", link: "/golden7-profilehome", group: "Self Reflection" },
    { label: "Applause", emoji: "👏", link: "/applause-hub-home", group: "Self Reflection" },
    { label: "Responsible Indian", emoji: "🌏", link: "/rim", group: "Self Reflection" },
    { label: "Teen Presentation", emoji: "📊", link: "/visualbrief-home", group: "Self Reflection" },
    { label: "Teen Forum", emoji: "🗣️", link: "/povify-home", group: "Self Reflection" },

    // 🏅 RECOGNITION & PROGRESS
    { label: "Certificates", emoji: "🏆", link: "/golden7score", group: "Recognition & Progress" },

    { label: "Youth Ranking", emoji: "🏆", link: "/golden7score", group: "Recognition & Progress" },
    { label: "Self Applause", emoji: "👏", link: "/self-applause", group: "Recognition & Progress" },
    { label: "I Was Appreciated", emoji: "👏", link: "/applause-for-me", group: "Recognition & Progress" },
    { label: "Youth Database", emoji: "🗄️", link: "/golden7db", group: "Recognition & Progress" },
    { label: "Teen Innovations", emoji: "💡", link: "/golden7-innovationhub", group: "Recognition & Progress" },

    // 🎬 Wishes & Fun
    { label: "Youth Mind Games", emoji: "🎮", link: "/golden7-games", group: "Wishes & Fun" },
    { label: "SpotSnap", emoji: "🖼️", link: "/spotsnap", group: "Wishes & Fun" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-yellow-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-black border-b border-yellow-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-400">🤙 Golden7</div>
          <div className="text-xs lg:text-lg text-yellow-200">
            Transforming Teengaer, Guidance and Values Ecosystem.
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs text-left text-yellow-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 mt-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-yellow-700 text-sm text-yellow-200 hover:bg-yellow-900"
              >
                Login
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-sm text-white bg-yellow-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-yellow-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-yellow-300 text-xs font-medium whitespace-nowrap h-7">
                {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-yellow-300 hover:text-yellow-300">
                Login
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-yellow-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="mx-auto px-3 flex flex-wrap justify-center gap-2 text-xs lg:text-sm">
          <a href="/golden7-insights" className="hover:text-yellow-200">💭 About</a>
          <a href="/rim" className="hover:text-yellow-300">🌏 RIM</a>
          <Link to="/smile" className="hover:text-yellow-200">📖🌈 SMILE</Link>
          <a href="/golden7-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/golden7-faq" className="hover:text-yellow-200">🤔 FAQ</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>
        </div>
        <div className="text-xs lg:text-sm text-center my-1 mx-1 mt-2  text-yellow-200/90">
           Extending Responsible Use of Digital Devices for Teenagers / Young Adults to Support Continuous Edutainment & Self-improvement!
        </div>
        {/* <div className="mt-3 flex flex-wrap justify-center gap-3 text-xs lg:text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-[12px] lg:text-lg">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div> */}
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-yellow-700">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-2 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-purple-700 text-yellow-200 shadow-md"
                  : "bg-yellow-800 text-yellow-100 hover:bg-yellow-900"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-yellow-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[14px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-yellow-700 hover:text-yellow-200 text-yellow-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      <footer className="bg-black border-t border-yellow-800 text-yellow-300 py-4">
        <div className="mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-white">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default MatrikaHome;


  